enum CaseReports {
  SUPPLEMENTAL_DATA = "Supplemental Data",
}
export default CaseReports;
